import { GameConstants } from "../../GameConstants";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManager";
import { HUD } from "./HUD";
import { GUI } from "./GUI";
import { PauseLayer } from "./PauseLayer";
import { MatchOverLayer } from "./MatchOverLayer";
import { AudioManager } from "../../AudioManager";
import {GameVars} from "../../GameVars";

export class BoardState extends Phaser.State {
    
    public static currentInstance: BoardState;  

    public hud: HUD;
    public gui: GUI;
    public pauseLayer: PauseLayer;
    public matchOverLayer: MatchOverLayer;

    public init(): void {
        
        BoardState.currentInstance = this;

        BoardManager.init(this.game);

        this.pauseLayer = null;
    }
    
    public create(): void {
        
        const scaledItemsContainer = this.add.group();
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scale.y = GameVars.scaleY;
        scaledItemsContainer.alpha = 0;

        const background = this.add.image(0, 0, "background");
        this.add.existing(background);

        this.add.image(0, 180 * GameVars.scaleY, "background_shadow");
        const lowerShadow = this.add.image(0, GameConstants.GAME_HEIGHT, "background_shadow");
        lowerShadow.scale.y = -1;

        const menuBackground = this.add.image(-15, -15 * GameVars.scaleY, "texture_atlas_1", "minesweeper_bg3");
        menuBackground.scale.y = GameVars.scaleY;
        this.add.existing(menuBackground);

        this.hud = new HUD(this.game);
        this.add.existing(this.hud);

        this.gui = new GUI(this.game);
        this.add.existing(this.gui);

        const boardContainer = new BoardContainer(this.game);
        this.add.existing(boardContainer);

        this.camera.flash(0x3d2c2e, 350);

        AudioManager.playSound("soundtrack_loop", true);
    }

    public shutdown(): void {
        
        BoardState.currentInstance = null;
        
        super.shutdown();
    }

    public showMatchOverLayer(won: boolean): void {

        this.gui.matchOver(won);

        this.matchOverLayer = new MatchOverLayer(this.game, won);
        this.add.existing(this.matchOverLayer);
    }

    public showPauseLayer(): void {
        
        this.pauseLayer = new PauseLayer(this.game);
        this.add.existing(this.pauseLayer);

        AudioManager.changeSoundVolume("soundtrack_loop", .2);
    }

    public hidePauseLayer(): void {
        
        this.pauseLayer.destroy();
        this.pauseLayer = null;

        AudioManager.changeSoundVolume("soundtrack_loop", 1);
    }
}
